<template>
  <div class="changedutystatus">
    <section class="toolbar">
      <div class="toolbar-container">
        <router-link id="back-button-change-duty-status" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
        <h1>Change Duty Status</h1>
        <button v-if="startPressed" id="cyclerule-shift-stop" type="button" class="btn btn-default submit-section" v-on:click="stopDuty()">Stop</button>
        <button v-else id="cyclerule-shift-start" type="button" class="btn btn-default submit-section" v-on:click="startDuty()">Start</button>
      </div>
    </section>
    <div class="clearfix"></div>
    <section class="duty-section duty-section-new">
      <div class="duty-container">
        <div class="duty-container-left">
          <h3 class="large-text">Duty Status</h3>
        </div>
        <div v-if="startPressed" class="duty-container-right">
          <div class="duty-status">
            <a href="javascript:void(0)" class="duty-off" v-bind:class="{active : statusOFF}" v-on:click="changeDuty('off')">Off</a>
            <a href="javascript:void(0)" class="duty-sb" v-bind:class="{active : statusSB}" v-on:click="changeDuty('sb')">SB</a>
            <a href="javascript:void(0)" class="duty-on" v-bind:class="{active : statusON}" v-on:click="changeDuty('on')">On</a>
          </div>
        </div>
        <div v-else class="duty-container-press-right">
          press START
        </div>
      </div>
    </section>
    <div class="clearfix"></div>
    <section class="change-duty-status">
      <div class="change-duty-status-container">
        <form>
          <div class="form-group cus-relative">
            <label for="lname">Location:</label>
            <input type="text" class="form-control" readonly id="location_name" name="location_name" v-model="locationName">
            <input type="hidden" class="form-control" id="longitude" name="longitude" v-model="longitude">
            <input type="hidden" class="form-control" id="latitude" name="latitude" v-model="latitude">
            <button id="get-location-to-change-duty" type="button" class="btn btn-default location-icon" v-on:click="getLocationConstant()">
              <i class="glyphicon glyphicon-map-marker"></i>
            </button>
          </div>
          <div class="form-group">
            <label for="comment">Notes</label>
            <textarea class="form-control" rows="5" id="note"></textarea>
          </div>
        </form>
      </div>
    </section>
    <section class="submit-section">
      <button id="change-duty-status-save" type="submit" class="btn btn-default" v-on:click="saveDutyStatus()">Save</button>
      <router-link id="change-duty-status-cancel-button" v-bind:to="'/operator/home-page'" tag="button" class="btn btn-default">Cancel</router-link>
    </section>
    
      <div class="custom-loading"  v-if="this.$config.loading">
        <div class="custom-loading-box">
          <i class="fa fa-truck faa-passing-reverse animated " aria-hidden="true"></i>
        </div>
      </div>
  
  
  </div>
</template>

<script>
export default {
  name: "assetselection",
  data: () => ({
    userAgent: "",
    ifSelectedVehicleEqual: false,
    ifSelectedVehicleNotEqual: true,
    latitude: "",
    longitude: "",
    locationName: "",
    statusON: false,
    statusOFF: false,
    statusSB: false,
    startPressed: true,
    showAlertBeforeStart: false,
    selectedDutyStatus: "",
    items: []
  }),
  beforeCreate: function() {
    
  },
  mounted: function() {
    if (!this.$config.MapsAPI) {
      let geoLocation = document.createElement("script");
      geoLocation.setAttribute(
        "src",
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyAxR9iECiPUyY6Tn0kAU2SFturhVMbOyIM"
      );
      document.head.appendChild(geoLocation);
      this.$config.MapsAPI = true;
    }
    this.getUserAgent();
    this.call();
    var status = this.$route.query.current_status;
    this.selectedDutyStatus = status;
    if (status == "on" || status == "start") {
      this.statusON = true;
    } else if (status == "sb") {
      this.statusSB = true;
    } else if (status == "off" || status == "stop") {
      this.statusOFF = true;
    }
  },
  methods: {
    getUserAgent: function() {
      this.userAgent = navigator.userAgent;
      console.log("UserAgent : " + this.userAgent);
    },
    startDuty: function() {
      // to enable the changing of duty statusgit pu
      var self = this;
      var r;
      if (self.showAlertBeforeStart) {
        r = confirm(
          "Your mandatory 10 hour break period will be broken if you start the shift now, are you sure about it?"
        );
      } else {
        r = confirm(
          "Are you sure, You want to START duty? Doing so will START your shift for today."
        );
      }
      if (r == true) {
        //var self = this;
        var note = $("#note").val();
        self.$config.loading = true;
        $.ajax({
          url: self.$config.API + "/v1/operator/change-duty-status",
          type: "POST",
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          timeout: 10000,
          data: {
            status: "start",
            latitude: self.latitude,
            longitude: self.longitude,
            locationname: self.locationName,
            note: note
          },
          success: function(data) {
            self.$config.loading = false;
            //enable screen
            $(".loading").addClass("hide");
            if (data.status == "success") {
              self.statusOFF = false;
              self.statusON = true;
              self.statusSB = false;
              self.$router.push("/operator/home-page");
            }
            self.startPressed = true;
          },
          error: function(jqXHR, exception, textstatus) {
            self.$config.loading = false;
            //if session expired
            if (textstatus === "timeout") {
              alert("Request timeout");
            } else if (jqXHR.responseJSON.code == 401) {
              self.$router.push("/v1/operator/login");
            } else if (jqXHR.responseJSON.code == 400) {
              alert(jqXHR.responseJSON.messge);
            }
          }
        });
      }
    },
    getLocationConstant: function(flag) {
      // $(".loading").removeClass("hide");

      var self = this;
      self.$config.loading = true;
      if (navigator.geolocation) {
        var abc = navigator.geolocation.getCurrentPosition(
          self.onGeoSuccess,
          self.onGeoError,
          {enableHighAccuracy: true, timeout: 10000}
        );
      } else {
        console.log("No GPS support");
      }
    },
    onGeoSuccess: function(event) {
      var self = this;
      self.longitude = event.coords.longitude;
      self.latitude = event.coords.latitude;
      self.codeLatLong(event.coords.latitude, event.coords.longitude);
    },

    onGeoError: function(event) {
      // $(".loading").addClass("hide");
      var self = this;
      self.$config.loading = false;
      console.log("Error code " + event.code + ". " + event.message);
    },
    codeLatLong: function(lat, long) {
      var self = this;
      var geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(lat, long);
      geocoder.geocode({ latLng: latlng }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          //console.log(results);
          if (results[1]) {
            //formatted address
            //var address = results[0].formatted_address;
            self.locationName = results[0].formatted_address;
            //console.log(self.location_name);
            //alert("address = " + address);
            self.$config.loading = false;
          } else {
            alert("No results found");
          }
        } else {
          alert("Geocoder failed due to: " + status);
        }
      });
      // $(".loading").addClass("hide");
      self.$config.loading = false;
    },
    changeDuty: function(status) {
      var self = this;
      //make empty last location
      $("#longitude").val("");
      $("#latitude").val("");
      $("#duty_status").val("");
      $("#screen").val("");
      self.selectedDutyStatus = status;
      if (status == "off") {
        self.statusOFF = true;
        self.statusON = false;
        self.statusSB = false;
      } else if (status == "sb") {
        self.statusOFF = false;
        self.statusON = false;
        self.statusSB = true;
      } else if (status == "on") {
        self.statusOFF = false;
        self.statusON = true;
        self.statusSB = false;
      }
    },
    saveDutyStatus: function() {
      var self = this;
      var note = $("#note").val();
      if (self.userAgent == "vtrleld_app") {
        Native.stopLocationServices();
      }
      self.$config.loading = true;
      $.ajax({
        url: self.$config.API + "/v1/operator/change-duty-status",
        type: "POST",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        timeout: 10000,
        data: {
          status: self.selectedDutyStatus,
          latitude: self.latitude,
          longitude: self.longitude,
          locationname: self.locationName,
          note: note
        },
        success: function(data) {
          self.$config.loading = false;
          //enable screen
          $(".loading").addClass("hide");
          if (data.status == "success") {
            self.$router.push("/operator/home-page");
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          //if session expired
          if (textstatus === "timeout") {
            alert("Request timeout");
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/v1/operator/login");
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.messge);
          }
        }
      });
    },
    call: function() {
      var self = this;
      // self.$config.loading = true;
      $.ajax({
        url: self.$config.API + "/v1/operator/change-duty-status",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        timeout: 10000,
        success: function(data) {
          console.log("Before : " + self.$config.loading)
          self.$config.loading = false;
           console.log("After : " + self.$config.loading)
          console.log(data);
          if (data.status == "success" && data.data.stop_pressed == true) {
            self.startPressed = false;
            self.showAlertBeforeStart = data.data.show_alert;
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          if (textstatus === "timeout") {
            alert("Request timeout");
          }
        }
      });
    },
    stopDuty: function() {
      var r = confirm(
        "Are you sure, You want to STOP duty? Doing so will STOP your shift for today."
      );
      if (r == true) {
        var self = this;
        var note = $("#note").val();
        if (self.userAgent == "vtrleld_app") {
          Native.stopLocationServices();
        }
        self.$config.loading = true;
        $.ajax({
          url: self.$config.API + "/v1/operator/change-duty-status",
          type: "POST",
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          timeout: 10000,
          data: {
            status: "stop",
            latitude: self.latitude,
            longitude: self.longitude,
            locationname: self.locationName,
            note: note
          },
          success: function(data) {
            self.$config.loading = false;
            //enable screen
            $(".loading").addClass("hide");
            if (data.status == "success") {
              self.statusOFF = true;
              self.statusON = false;
              self.statusSB = false;
              self.$router.push("/operator/home-page");
            }
          },
          error: function(jqXHR, exception, textstatus) {
            self.$config.loading = false;
            //if session expired
            if (textstatus === "timeout") {
              alert("Request timeout");
            } else if (jqXHR.responseJSON.code == 401) {
              self.$router.push("/v1/operator/login");
            } else if (jqXHR.responseJSON.code == 400) {
              alert(jqXHR.responseJSON.messge);
            }
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
 


// WEBPACK FOOTER //
// src/components/changedutystatus.vue